import { number } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { registerValidator, Validation } from '@philips-emr/tws-core/lib/services/model-service';

export const MIN_LENGTH = 'min-length';

interface MinLengthValidatorOptions {
  min?: number;
}

function MinLengthValidator(value: any, { min = Number.MIN_SAFE_INTEGER }: MinLengthValidatorOptions = {}): Validation[] {
  const current = value === undefined || value === null ? 0 : String(value).length;
  const valid = current >= min;

  return [{
    message: valid ? '' : msg('tws.validator.min-length-unmet', {
      missing: min - current,
      limit: min,
    }),
    name: MIN_LENGTH,
    valid,
  }];
}

MinLengthValidator.optionTypes = {
  min: number,
};

export default registerValidator(MIN_LENGTH, MinLengthValidator);
